import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const customerOnlyRoutes = ['/add-credit', '/history', '/settings', '/subscription', '/machines', '/account'];
  const isCustomerRoute = customerOnlyRoutes.some((route) => location.pathname.startsWith(route));

  if (user.role === 'maintenance_employee' && isCustomerRoute) {
    return <Navigate to="/my-schedule" replace />;
  }

  if (user.role === 'partner' && isCustomerRoute) {
    return <Navigate to="/parceiro" replace />;
  }

  return <>{children}</>;
};